var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermVsTempEmps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34411)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 12H28.0477V23.1628H17.2266V12Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9032 23.1062C25.7141 23.1062 27.8981 20.024 27.8981 17.3751C27.9051 17.0404 27.8805 16.7093 27.8241 16.3782C27.7678 16.0506 27.6762 15.7301 27.5564 15.4201C27.4331 15.1101 27.2852 14.8142 27.102 14.5324C26.9224 14.2506 26.7145 13.9899 26.482 13.7504C26.2496 13.5144 25.9959 13.2995 25.7212 13.1093C25.4429 12.9226 25.1505 12.7641 24.8441 12.6338C24.5376 12.5034 24.2206 12.4048 23.893 12.3379C23.5654 12.2745 23.2343 12.2393 22.8996 12.2393C22.565 12.2393 22.2374 12.2745 21.9098 12.3379C21.5822 12.4048 21.2652 12.5034 20.9552 12.6338C20.6488 12.7641 20.3564 12.9226 20.0816 13.1093C19.8069 13.2995 19.5533 13.5144 19.3172 13.7504C19.0848 13.9899 18.8805 14.2506 18.6973 14.5324C18.5176 14.8142 18.3662 15.1101 18.2464 15.4201C18.1231 15.7301 18.0351 16.0506 17.9787 16.3782C17.9188 16.7093 17.8942 17.0404 17.9047 17.3751C17.9047 20.024 20.0852 23.1062 22.9032 23.1062ZM22.9032 13.1164C23.1814 13.1164 23.4597 13.1445 23.731 13.1974C24.0057 13.2537 24.2734 13.3348 24.5306 13.4404C24.7877 13.5496 25.0343 13.68 25.2633 13.835C25.4957 13.9899 25.7106 14.1661 25.9079 14.3669C26.1051 14.5641 26.2813 14.779 26.4363 15.0115C26.5912 15.244 26.7216 15.487 26.8308 15.7442C26.9364 16.0048 27.0175 16.269 27.0703 16.5438C27.1267 16.8185 27.1548 17.0933 27.1548 17.3751C27.1548 19.6823 25.295 22.363 22.9032 22.363C20.5079 22.363 18.648 19.6823 18.648 17.3751C18.648 17.0933 18.6762 16.8185 18.729 16.5438C18.7854 16.269 18.8664 16.0048 18.972 15.7442C19.0777 15.487 19.2081 15.2404 19.363 15.008C19.5216 14.7755 19.6977 14.5606 19.8949 14.3633C20.0922 14.1661 20.3071 13.9899 20.5396 13.835C20.772 13.68 21.0151 13.5461 21.2758 13.4404C21.5329 13.3348 21.7971 13.2537 22.0719 13.1974C22.3466 13.1445 22.6214 13.1164 22.9032 13.1164Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13506_34411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 23,
    width: 24,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.1621H37.6502V37.0021H14V23.1621Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13506_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6367 27.9773H33.6429V26.9065C33.6429 26.7621 33.6112 26.6212 33.5549 26.4873C33.495 26.3535 33.414 26.2372 33.3118 26.1351C33.2061 26.0329 33.0864 25.9519 32.9525 25.899C32.8151 25.8427 32.6742 25.8145 32.5298 25.8145H30.7404C29.821 24.7789 28.4155 24.328 25.3474 24.0215C25.1924 24.0075 25.0727 24.0673 24.9952 24.1977L24.2977 25.3777L24.1181 24.5253C24.0793 24.321 23.9525 24.2223 23.7447 24.2259H22.0292C21.8214 24.2223 21.6981 24.321 21.6558 24.5253L21.5149 25.3777L20.8175 24.2188C20.7364 24.085 20.6202 24.0251 20.4652 24.0392C17.154 24.328 14.0859 25.0396 14.0859 28.3507V32.9723C14.0859 33.0744 14.1212 33.1625 14.1916 33.2364C14.2656 33.3069 14.3536 33.3421 14.4558 33.3421H25.3157V35.202C25.3192 35.4274 25.3615 35.6423 25.446 35.8502C25.5341 36.058 25.6574 36.2411 25.8159 36.3997C25.9744 36.5582 26.1576 36.6815 26.3654 36.766C26.5733 36.8541 26.7916 36.8963 27.0171 36.8963H35.6367C35.8621 36.8963 36.077 36.8541 36.2848 36.766C36.4927 36.6815 36.6758 36.5582 36.8343 36.3997C36.9928 36.2411 37.1161 36.058 37.2007 35.8502C37.2852 35.6423 37.331 35.4274 37.331 35.202V29.6752C37.331 29.4497 37.2887 29.2349 37.2007 29.027C37.1161 28.8192 36.9928 28.636 36.8343 28.4775C36.6758 28.319 36.4927 28.1957 36.2848 28.1077C36.077 28.0231 35.8621 27.9773 35.6367 27.9773ZM32.9173 26.9065V27.9773H29.7365V26.9065C29.7365 26.8114 29.7682 26.7304 29.8386 26.6599C29.9055 26.593 29.9901 26.5578 30.0852 26.5578H32.5474C32.6425 26.5648 32.7236 26.6 32.7905 26.667C32.8609 26.7339 32.8962 26.8149 32.8997 26.9065H32.9173ZM22.3321 24.9691H23.4488L23.7447 26.3112L22.9204 27.6885L22.0715 26.3077L22.3321 24.9691ZM14.8292 32.6024V28.3507C14.8292 25.5855 17.5063 25.0713 20.2856 24.7859L22.5858 28.6008C22.621 28.6572 22.6668 28.703 22.7231 28.7347C22.7795 28.7664 22.8394 28.7805 22.9028 28.7805C22.9697 28.7805 23.0296 28.7664 23.086 28.7347C23.1423 28.703 23.1881 28.6572 23.2233 28.6008L24.428 26.593L25.5095 24.793C27.8977 25.0396 29.0249 25.3848 29.7224 25.9096C29.5005 25.9836 29.3208 26.1139 29.1834 26.3006C29.0496 26.4908 28.9791 26.7022 28.9791 26.9347V27.9773H27.0171C26.7916 27.9773 26.5733 28.0231 26.3654 28.1077C26.1576 28.1957 25.9744 28.319 25.8159 28.4775C25.6574 28.636 25.5341 28.8192 25.446 29.027C25.3615 29.2349 25.3192 29.4497 25.3157 29.6752V32.6024H14.8292ZM36.5737 35.202C36.5737 35.3253 36.549 35.4486 36.5032 35.5613C36.4539 35.6775 36.387 35.7797 36.2989 35.8678C36.2108 35.9593 36.1122 36.0263 35.996 36.0756C35.8797 36.1249 35.76 36.1496 35.6367 36.1531H27.0171C26.8903 36.1531 26.767 36.1284 26.6507 36.0791C26.5345 36.0333 26.4323 35.9629 26.3408 35.8748C26.2527 35.7867 26.1823 35.6811 26.1329 35.5648C26.0871 35.4486 26.0625 35.3288 26.059 35.202V29.6752C26.059 29.5484 26.0836 29.4286 26.1329 29.3124C26.1823 29.1926 26.2492 29.0904 26.3408 29.0024C26.4288 28.9108 26.5345 28.8439 26.6507 28.7946C26.767 28.7452 26.8903 28.7206 27.0171 28.7206H35.6367C35.7635 28.7206 35.8833 28.7452 35.9995 28.7946C36.1157 28.8439 36.2214 28.9143 36.3095 29.0024C36.3975 29.0904 36.468 29.1961 36.5138 29.3124C36.5631 29.4286 36.5878 29.5484 36.5878 29.6752L36.5737 35.202Z",
    fill: "#06513D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9997 30.9218L30.77 33.1515L29.6569 32.0349C29.5829 31.9715 29.4948 31.9433 29.3997 31.9468C29.3011 31.9503 29.2201 31.9856 29.1496 32.056C29.0827 32.1229 29.0475 32.2075 29.0439 32.3026C29.0369 32.4012 29.0686 32.4858 29.132 32.5597L30.5128 33.9405C30.5868 34.0145 30.6749 34.0533 30.777 34.0533C30.8792 34.0533 30.9672 34.0145 31.0412 33.9405L33.5492 31.4325C33.6126 31.3585 33.6408 31.274 33.6373 31.1789C33.6338 31.0803 33.5985 30.9992 33.5316 30.9288C33.4612 30.8619 33.3801 30.8231 33.2815 30.8196C33.1864 30.8161 33.0983 30.8478 33.0244 30.9112L32.9997 30.9218Z",
    fill: "#06513D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 23.2048C34.625 23.2893 34.6955 23.3598 34.78 23.3598H35.8649C35.9495 23.3598 36.0199 23.2893 36.0199 23.2048C36.0199 23.1167 35.9495 23.0498 35.8649 23.0498H34.78C34.6955 23.0498 34.625 23.1167 34.625 23.2048Z",
    fill: "#06513D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9323 22.7397H36.0173C36.1018 22.7397 36.1723 22.6692 36.1723 22.5847C36.1723 22.5001 36.1018 22.4297 36.0173 22.4297H34.9323C34.8478 22.4297 34.7773 22.5001 34.7773 22.5847C34.7773 22.6692 34.8478 22.7397 34.9323 22.7397Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13506_34411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 18,
    width: 11,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8477 18.6514H39.1119V24.1747H29.8477V18.6514Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13506_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7541 19.5042C38.6695 19.395 38.5533 19.3351 38.43 19.3351H37.331C37.331 19.3351 37.3556 19.2717 37.3556 19.2646C37.3838 19.1695 37.3627 19.0639 37.2993 18.9864C37.2464 18.9089 37.1548 18.8701 37.0597 18.8701H35.4605C35.3267 18.8701 35.2034 18.9617 35.1717 19.085L35.0942 19.3351H31.3814C31.1595 19.3351 30.9869 19.55 30.9482 19.7507L30.6875 20.8815C30.7932 20.8885 30.8953 20.8956 30.994 20.9202L31.2511 19.8142C31.2758 19.712 31.3427 19.6345 31.3814 19.6345H35.2034C35.2738 19.6345 35.3267 19.5887 35.3513 19.5253L35.4676 19.1695C35.4676 19.1695 35.4676 19.1695 35.4676 19.1625H37.0527L36.9681 19.4196C36.9505 19.4654 36.9611 19.5183 36.9893 19.557C37.021 19.5958 37.0668 19.6204 37.1161 19.6204H38.43C38.5286 19.6204 38.585 19.7895 38.5603 19.874L37.5247 23.9919C37.5106 24.0588 37.4542 24.1081 37.3944 24.1081H32.0155C31.9098 24.2208 31.783 24.33 31.6456 24.4146H37.3944C37.6022 24.4146 37.7783 24.2701 37.8276 24.0588L38.8633 19.9445C38.902 19.8142 38.8633 19.6345 38.7541 19.5042Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13506_34411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 18,
    width: 10,
    height: 4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9766 18.0977H37.0643V21.3595H28.9766V18.0977Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13506_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7514 18.5626C29.7514 18.4781 29.8218 18.4076 29.9064 18.4076H36.0954C36.18 18.4076 36.2504 18.4781 36.2504 18.5626H36.5569C36.5569 18.309 36.3491 18.0977 36.0954 18.0977H29.9064C29.6492 18.0977 29.4414 18.309 29.4414 18.5626V21.2714C29.533 21.201 29.6422 21.1305 29.7514 21.0777V18.5626Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13506_34411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 20,
    width: 5,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9766 20.4551H32.5554V24.1749H28.9766V20.4551Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13506_34411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2278 22.8163C32.2278 21.918 31.4987 21.1924 30.6004 21.1924C29.7057 21.1924 28.9766 21.918 28.9766 22.8163C28.9766 23.7145 29.7057 24.4401 30.6004 24.4401C31.4987 24.4401 32.2278 23.7145 32.2278 22.8163ZM30.6004 24.1302C29.8748 24.1302 29.2865 23.5419 29.2865 22.8163C29.2865 22.0871 29.8748 21.4988 30.6004 21.4988C31.3296 21.4988 31.9179 22.0871 31.9179 22.8163C31.9179 23.5419 31.3296 24.1302 30.6004 24.1302Z",
    fill: "#06513D"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8559 20.9057C31.9263 20.9057 31.9968 20.8529 32.0109 20.7825L32.0496 20.5746H32.4758C32.5604 20.5746 32.6308 20.5042 32.6308 20.4196C32.6308 20.3351 32.5604 20.2646 32.4758 20.2646H31.9193C31.8418 20.2646 31.7784 20.3175 31.7643 20.3879L31.7009 20.7226C31.6868 20.8212 31.7643 20.9057 31.8559 20.9057Z",
    fill: "#06513D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0213 23.0098C31.053 22.9464 31.067 22.8865 31.067 22.816C31.067 22.6152 30.9367 22.4426 30.7571 22.3757V21.9636C30.7571 21.879 30.6901 21.8086 30.6021 21.8086C30.5175 21.8086 30.4506 21.879 30.4506 21.9636V22.3757C30.271 22.4356 30.1406 22.6082 30.1406 22.816C30.1406 23.0697 30.3485 23.281 30.6021 23.281C30.6725 23.281 30.743 23.2634 30.8064 23.2317L31.1234 23.5276C31.1833 23.5804 31.2854 23.5804 31.3383 23.5205C31.3911 23.4571 31.3911 23.3585 31.3312 23.3021L31.0213 23.0098ZM30.4506 22.816C30.4506 22.7315 30.5175 22.661 30.6021 22.661C30.6901 22.661 30.7571 22.7315 30.7571 22.816C30.7571 22.9006 30.6901 22.971 30.6021 22.971C30.5175 22.971 30.4506 22.9006 30.4506 22.816Z",
    fill: "#06513D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34411",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34411",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermVsTempEmps);
export default __webpack_public_path__ + "static/media/PermVSTempEmps.51f3d5639e3e4c2499e450d7d28e20fd.svg";
export { ForwardRef as ReactComponent };